module.exports = __webpack_public_path__ + "static/media/x-icon.08e8226a.svg";